import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'
import { layout } from 'styled-system'

import { motion } from 'framer-motion'

import { ANIMATION } from 'Constants/Animation'

const Container = styled(motion.div)`
  ${layout};
`

const Motion = ({ children, variants, ...rest }) => (
  <Container variants={variants} {...rest}>
    {children}
  </Container>
)

Motion.defaultProps = {
  children: null,
  variants: ANIMATION.childVariants,
}

Motion.propTypes = {
  children: PropTypes.any,
  variants: PropTypes.object,
}

export default Motion
